import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.813 14.063a2.064 2.064 0 010-4.126 2.063 2.063 0 010 4.126zM12 14.063a2.064 2.064 0 010-4.126 2.063 2.063 0 010 4.126zM18.187 14.063a2.064 2.064 0 010-4.126 2.063 2.063 0 010 4.126z"
}), 'More');